import React from 'react'
import styled from 'styled-components'
import { ChevronLeft as BaseChevronLeft, ExpandMore as BaseExpandMore } from '@material-ui/icons'
import { Collapse as BaseCollapse, Grid as BaseGrid } from '@material-ui/core'

export const ButtonConsiderationText = styled.h5`
  font-size: 14px;
`

export const DesktopNavigation = styled.div`
  display: flex;

  ${props => props.theme.breakpoints.down('md')} {
    justify-content: center;
  }
`

export const Divided = styled.hr`
  border: 1px solid ${props => props.theme.palette.gray[90]};
  margin: ${props => props.margin};
  width: ${props => props.width || 'auto'};
`

export const Instructions = styled.p`
  color: ${props => props.theme.palette.custom.charcoal};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 22px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 1.3;
  margin: 0;

  ${props => props.theme.breakpoints.only('xs')} {
    text-align: center;
  }
`

export const Item = styled.div`
  border-bottom: 2px solid ${props => props.theme.palette.gray[90]};
  cursor: pointer;
  padding: 0 20px;
  width: 100%;
`

export const ItemBody = styled(BaseCollapse)`
  & .MuiCollapse-wrapperInner {
    color: ${props => props.theme.palette.custom.charcoal};
    font-family: ${props => props.theme.typography.fontFamily};
    font-size: 16px;
    font-weight: 300;
    letter-spacing: 0;
    margin: 8px 0 14px;
    max-width: 613px;
    width: 100%;
  }
`

export const ItemCollapseIcon = styled(BaseExpandMore)`
  color: ${props => props.theme.palette.brand.black3};
  font-size: 22px;
`

export const ItemExpandIcon = styled(BaseChevronLeft)`
  color: ${props => props.theme.palette.brand.black3};
  font-size: 22px;
`

export const ItemHeader = styled.div`
  align-items: center;
  display: grid;
  grid-column-gap: 10px;
  grid-template-columns: auto 22px;
  height: 50px;
`

export const ItemTitle = styled.div`
  color: ${props => props.theme.palette.custom.charcoal};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  letter-spacing: 0;
  margin: 0;
`

export const ItemToggle = styled.div`
  display: block;
`

export const MobileNavigation = styled.div`
  align-items: center;
  background-color: ${props => props.theme.palette.custom.ghostWhite};
  bottom: 0;
  box-shadow: 0 -3px 10px ${props => props.theme.palette.custom.ghostBlack};
  display: flex;
  height: 90px;
  justify-content: center;
  left: 0;
  position: fixed;
  width: 100%;
`

export const Root = styled.div`
  box-sizing: border-box;
  padding: 0 0 130px;
  width: 100%;
`

export const Section = styled(({ margin, maxWidth, ...props }) => <BaseGrid {...props} />)`
  margin: ${props => props.margin || 'initial'};
  max-width: ${props => props.maxWidth || 'initial'};

  &.MuiGrid-item {
    margin: ${props => props.margin || 'initial'};
  }
`

export const Title = styled.h1`
  color: ${props => props.theme.palette.custom.mineShaft};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 34px;
  font-weight: 300;
  letter-spacing: 0;
  margin: 0;

  ${props => props.theme.breakpoints.only('xs')} {
    text-align: center;
  }
`
